import { useState } from "react";
import { Button, Col, Pagination, Row, Table, TableColumnsType } from "antd";
import {
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

import { CreateCampaignModal } from "./CreateCampaign";
import { downloadPhonebookFailed, getDialerPhonebooks } from "../../services/commonController";
import { CheckCircleOutlined, CloseCircleOutlined, DownloadOutlined } from "@ant-design/icons";
import { convertToCustomFormat } from "../../utils";
import { PhonebookTableColumnsTypes } from "../../components/Dashboards/Tables/Columns";
import { useQueryClient } from "@tanstack/react-query";

 const phonebookTableColumn: TableColumnsType<PhonebookTableColumnsTypes> =
  [
    {
      title: "NAME",
      dataIndex: "phonebookname",
      render: (phonebookname) => <span>{phonebookname || "-"}</span>,
    },
    {
      title: "PHONEBOOK ID",
      dataIndex: "id",
      render: (id) => <span>{id || "-"}</span>,
    },
    {
      title: "CREATED ON",
      dataIndex: "timestamp",
      render: (timestamp) => (
        <span>{convertToCustomFormat(timestamp) || "-"}</span>
      ),
    },
    {
      title: "COUNT",
      dataIndex: "totalLoanId",
      render: (totalLoanId: number, record: PhonebookTableColumnsTypes) => (
        <span>
          Total Uploaded: {totalLoanId} |{"  "}
          <CheckCircleOutlined className="text-green-500  align-right" />{" "}
          Success: {record.successCount} |{"  "}
          <CloseCircleOutlined className="text-red-500  align-middle" /> Failed:{" "}
          {record.failedCount}
          <DownloadOutlined
            className="text-blue-500 text-xs align-middle ml-1 cursor-pointer"
             onClick={() => handleDownloadFailed(record)}
          />
          <br />
          <span>
            Total Due Amount:{" "}
            {record?.totalDueAmount ? `₹  ${record?.totalDueAmount}` : "-"}
          </span>
          <br />
          <span>
            DND/NDNC: {record?.ndncCount || "NA"} | Invalid:{" "}
            {record?.invalidCount} | Duplicate: {record?.duplicatesCount}
          </span>
        </span>
      ),
    },
  ];

  const handleDownloadFailed = async (
  record: PhonebookTableColumnsTypes
) => {
  try {
   const response: any = await downloadPhonebookFailed(record.invalidUrl);

const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = "Failed_Loan_Ids.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    // message.error("Failed to download file.");
  }
};
export const SolveesyDiallerTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
const queryClient = useQueryClient();

const handleOpenModal = () => {
  setIsModalOpen(true);
};

const handleCloseModal = () => {
  setIsModalOpen(false);
};


const refetchPhonebooks = () => {
  queryClient.invalidateQueries({
    queryKey: ["dialerPhonebooks"],
    exact: false,
  });
};

  const {
    data: phonebooks,
    isPending,
    isRefetching,
  } = useQuery({
    queryKey: ["dialerPhonebooks", currentPage],
    queryFn: () => getDialerPhonebooks(currentPage, 100),
    placeholderData: keepPreviousData,
    refetchOnMount: true,
  });

const sortedData = (phonebooks?.data ?? []).slice().sort(
  (a: any, b: any) =>
    new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
);

  return (
    <Col>
      <Row className="flex justify-end items-center mb-5">
       <Button onClick={handleOpenModal}>
  Create Phonebook
</Button>
      </Row>

      <Table
        loading={isPending || isRefetching}
        columns={phonebookTableColumn}
        dataSource={sortedData || []}
        rowKey={(record: any) => record.id}
        pagination={false}
        scroll={{ y: 850 }}
        virtual
      />

      <Row className="flex justify-center pt-6 pb-6">
        <Pagination
          current={phonebooks?.currentPage || currentPage}
          total={phonebooks?.totalResults || 0}
          pageSize={phonebooks?.pageSize || 10}
          pageSizeOptions={["10", "20", "50", "100", "500", "1000"]}
          onChange={(page) => setCurrentPage(page)}
        />
      </Row>
 <CreateCampaignModal
  status={isModalOpen}
  onCancel={handleCloseModal}
  refetchPhonebooks={refetchPhonebooks}
/>
     
    </Col>
  );
};